import {complement} from '@packages/utilities/fp/utils';
import {QualifiedMap} from '@packages/systems/wfdl-Qualified';
import * as VariableMap from '../VariableMap';
import * as Variable from '../Variable';
import {
  type EvalEnvType,
  type Value,
  create,
  getParsers,
  getValues,
} from './EvalEnv';

export * from './EvalEnv';

export const emptyEvalEnv: EvalEnvType = create({
  parsers: QualifiedMap.empty(),
  values: VariableMap.empty(),
});

export const insertValue = (
  env: EvalEnvType,
  variable: Variable.VariableType,
  value: Value
): EvalEnvType => {
  const prevValues = getValues(env);
  const values = VariableMap.insert(prevValues, variable, value);

  if (values === prevValues) {
    return env;
  }

  return create({parsers: getParsers(env), values});
};

export function removeValue(
  env: EvalEnvType,
  variable: Variable.VariableType
): EvalEnvType {
  const values = getValues(env);

  if (VariableMap.get(values, variable) === undefined) {
    return env;
  }

  return create({
    parsers: getParsers(env),
    values: VariableMap.filter(values, complement(Variable.equals(variable))),
  });
}
